import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import i18n from "../../../../constants/i18n";
import {
  ACCOUNT_CREATED_ON_DATE_RANGES,
  ALLOWED_AGES,
  ALLOWED_HEIGHTS,
  ALLOWED_WEIGHTS,
  COUNTRIES,
  USER_ADVANCED_CRITERIA_FIELD_SIZE
} from "../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import FilterSelect from "../../../khattabat/matching/search-and-101m/form/FilterSelect";

const KhattabatAdvancedCriteriaFields = withLiteObserverAndTheme(() => {
  const {
    criteriaSearchUserName,
    criteriaSearchNationality,
    criteriaSearchResidenceCountry,
    criteriaSearchAge,
    criteriaSearchHeight,
    criteriaSearchWeight,
    criteriaSearchDescription,
    criteriaSearchPeerDescription,
    criteriaSearchAccountCreatedOn,
    setCriteriaSearchUserName,
    setCriteriaSearchNationality,
    setCriteriaSearchResidenceCountry,
    setCriteriaSearchAge,
    setCriteriaSearchHeight,
    setCriteriaSearchWeight,
    setCriteriaSearchDescription,
    setCriteriaSearchPeerDescription,
    setCriteriaSearchAccountCreatedOn
  } = getUserAdvancedStore();

  return (
    <Grid container spacing={2}>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <TextField
          size="small"
          fullWidth
          label={i18n.get("USER_NAME")}
          value={criteriaSearchUserName.get()}
          onChange={({ target }) => setCriteriaSearchUserName(target.value)}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("NATIONALITY")}
          options={COUNTRIES()}
          value={criteriaSearchNationality.get()}
          onChange={setCriteriaSearchNationality}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("COUNTRY_OF_RESIDENCE")}
          options={COUNTRIES()}
          value={criteriaSearchResidenceCountry.get()}
          onChange={setCriteriaSearchResidenceCountry}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("AGE")}
          options={ALLOWED_AGES}
          value={criteriaSearchAge.get()}
          onChange={setCriteriaSearchAge}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("HEIGHT")}
          options={ALLOWED_HEIGHTS}
          value={criteriaSearchHeight.get()}
          onChange={setCriteriaSearchHeight}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("WEIGHT")}
          options={ALLOWED_WEIGHTS}
          value={criteriaSearchWeight.get()}
          onChange={setCriteriaSearchWeight}
        />
      </Grid>
      <Grid size={USER_ADVANCED_CRITERIA_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("ACCOUNT_CREATED_ON")}
          options={ACCOUNT_CREATED_ON_DATE_RANGES}
          value={criteriaSearchAccountCreatedOn.get()}
          onChange={setCriteriaSearchAccountCreatedOn}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          size="small"
          fullWidth
          multiline
          minRows={2}
          label={i18n.get("DESCRIPTION")}
          value={criteriaSearchDescription.get()}
          onChange={({ target }) => setCriteriaSearchDescription(target.value)}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          size="small"
          fullWidth
          multiline
          minRows={2}
          label={i18n.get("KHATTABAT_PEER_DESCRIPTION")}
          value={criteriaSearchPeerDescription.get()}
          onChange={({ target }) =>
            setCriteriaSearchPeerDescription(target.value)
          }
        />
      </Grid>
    </Grid>
  );
});

export default KhattabatAdvancedCriteriaFields;
